import React, { FC, RefObject, CSSProperties, useMemo, useState, useCallback, useEffect } from 'react';
import cn from 'classnames';
import { Button, ButtonSizes, IButtonProps } from '../Button';
import { Badge } from '../Badge';
import { AmountCounter } from '../AmountCounter';
import { Icon } from '../Icon';
import { PriceCurrentValue } from './CurrentValue/PriceCurrentValue';
require("./Price.css");
var styles = {
  "Button": "Price-module-Button_2tp",
  "Content": "Price-module-Content_2VS",
  "fixedHeight": "Price-module-fixedHeight_24r",
  "Values": "Price-module-Values_1CZ",
  "Counter": "Price-module-Counter_3Ru",
  "OldValue": "Price-module-OldValue_1nQ",
  "Badge": "Price-module-Badge_28L",
  "Icon": "Price-module-Icon_Woz",
  "SrOnly": "Price-module-SrOnly_TSY",
  "columnVariant": "Price-module-columnVariant_3gJ",
  "lSize": "Price-module-lSize_lXe",
  "mSize": "Price-module-mSize_1Op"
};
export const PriceVariants = {
  column: 'column'
};
export const PriceSizes = {
  m: 'm',
  l: 'l'
};
export const Price = ({
  currentValue,
  oldValue,
  className,
  withCounter = false,
  counterPostfix = ' шт',
  discountPercent,
  countValue = '0',
  size = PriceSizes.m,
  style,
  variant,
  onCounterChange = () => {},
  onChangeCounterVisibility = () => {},
  controlRef,
  innerRef
}) => {
  const amountCounterPattern = [/[0-9]{1,3}/, counterPostfix];
  const [isCounterVisible, setIsCounterVisible] = useState(Number(countValue) > 0);
  const formattedOldValue = useMemo(() => {
    if (!oldValue) return '';
    return Number(oldValue).toLocaleString('ru-RU', {
      style: 'currency',
      currency: 'RUB',
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    }).slice(0, -2);
  }, [oldValue]);
  useEffect(() => {
    onChangeCounterVisibility(isCounterVisible);
  }, [onChangeCounterVisibility, isCounterVisible]);
  const handleCounterVisibility = useCallback(() => {
    setIsCounterVisible(true);
  }, []);
  const handleCounterChange = useCallback(newValue => {
    onCounterChange(newValue);
    if (Number(countValue) > 0 && newValue === '0') {
      setIsCounterVisible(false);
    }
  }, [onCounterChange, countValue]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.Root, styles[`${variant}Variant`], styles[`${size}Size`], className),
    ref: innerRef || controlRef,
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.Content, {
      [styles.fixedHeight]: withCounter && isCounterVisible && variant !== PriceVariants.column
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.Values
  }, withCounter ? /*#__PURE__*/React.createElement(React.Fragment, null, isCounterVisible ? /*#__PURE__*/React.createElement(PriceCurrentValue, {
    value: currentValue,
    size: size
  }) : /*#__PURE__*/React.createElement(Button, {
    size: ButtonSizes.s,
    "aria-label": `Добавить товар в корзину по цене ${currentValue} рублей`,
    className: styles.Button,
    onClick: handleCounterVisibility
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.ButtonContent
  }, /*#__PURE__*/React.createElement(PriceCurrentValue, {
    value: currentValue,
    size: size
  }), !isCounterVisible && /*#__PURE__*/React.createElement(Icon, {
    name: "plus",
    size: "m",
    className: styles.Icon
  })))) : /*#__PURE__*/React.createElement(PriceCurrentValue, {
    value: currentValue,
    size: size
  }), Boolean(oldValue) && Number(oldValue) > currentValue && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.OldValue,
    "aria-hidden": "true"
  }, formattedOldValue), /*#__PURE__*/React.createElement("span", {
    className: styles.SrOnly
  }, `Старая цена ${formattedOldValue}`))), Boolean(discountPercent) && /*#__PURE__*/React.createElement(Badge, {
    className: styles.Badge,
    content: `-${discountPercent}%`,
    bg: "#FF0066"
  })), withCounter && isCounterVisible && /*#__PURE__*/React.createElement(AmountCounter, {
    initialValue: countValue,
    onValueChange: handleCounterChange,
    type: "outline",
    size: "s",
    min: 0,
    pattern: amountCounterPattern,
    className: styles.Counter
  }));
};
if (process.env.NODE_ENV !== 'production') {
  Price.displayName = 'Price';
}